module.exports = __webpack_public_path__ + "static/media/HomeTab4.993fb9e6.jpg";